import { ActivatedRouteSnapshot, DetachedRouteHandle } from '@angular/router';

/**
 * å¤ç¨å¹éæ¨¡å¼
 */
export enum ReuseTabMatchMode {
  /**
   * ï¼æ¨èï¼æèå `Menu` éç½®
   *
   * å¯å¤ç¨ï¼
   * - `{ text:'Dashboard' }`
   * - `{ text:'Dashboard', reuse: true }`
   *
   * ä¸å¯å¤ç¨ï¼
   * - `{ text:'Dashboard', reuse: false }`
   */
  Menu,
  /**
   * æèå `Menu` å¼ºå¶éç½®
   *
   * å¯å¤ç¨ï¼
   * - `{ text:'Dashboard', reuse: true }`
   *
   * ä¸å¯å¤ç¨ï¼
   * - `{ text:'Dashboard' }`
   * - `{ text:'Dashboard', reuse: false }`
   */
  MenuForce,
  /**
   * å¯¹ææè·¯ç±ææï¼å¯ä»¥éå `excludes` è¿æ»¤æ é¡»å¤ç¨è·¯ç±
   */
  URL
}

export interface ReuseItem {
  /**
   * URL
   *
   * @type {string}
   * @memberof ReuseItem
   */
  url: string;
  /**
   * æ é¢
   *
   * @type {string}
   * @memberof ReuseItem
   */
  title: string;
  /**
   * æ¯å¦å¯å³é­
   *
   * @type {boolean}
   * @memberof ReuseItem
   */
  closable: boolean;
  /**
   * ç´¢å¼
   *
   * @type {number}
   * @memberof ReuseItem
   */
  index: number;
  /**
   * æ¯å¦æ¿æ´»
   *
   * @type {boolean}
   * @memberof ReuseItem
   */
  active: boolean;
  last: boolean;
}

export interface ReuseTitle {
  text: string;
  i18n?: string;
}

export interface ReuseTabCached {
  title: ReuseTitle;
  url: string;
  /** æ¯å¦åè®¸å³é­ï¼é»è®¤ï¼`true` */
  closable?: boolean;
  /** å½åæ»å¨æ¡ä½ç½® */
  position?: [number, number] | null;
  _snapshot: ActivatedRouteSnapshot;
  _handle: any;
}

export interface ReuseTabNotify {
  /** äºä»¶ç±»å */
  active: string;
  [key: string]: any;
}
